import React from "react";
import deleteModalIcon from "../../../assets/delete-modal-icon.svg";

function OutOfStockModal({ isOpen, onClose, onConfirm, orderItem }) {
  if (!isOpen) return null;

  const handleCancel = () => {
    if (onConfirm && orderItem) {
      onConfirm(orderItem);
    }
    onClose();
  };

  return (
    <div
      className="orders-cancel-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="orders-cancel-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancelOrderTitle"
      >
        <div className="orders-cancel-modal-icon">
          <img src={deleteModalIcon} alt="Cancel" />
        </div>
        <h3 className="orders-cancel-modal-title" id="cancelOrderTitle">
          Mark as Out Of Stock Confirmation
        </h3>
        <p className="orders-cancel-modal-message">
          Are you sure you want to mark this product as Out of Stock? This will
          remove it from the order total.
        </p>
        <div className="orders-cancel-modal-actions">
          <button
            type="button"
            className="orders-cancel-modal-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="orders-cancel-modal-delete-btn"
            onClick={handleCancel}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default OutOfStockModal;
